/** @file Number of drawn tiles of a sector table (highest tile index + 1; -1 entries draw nothing). */
import type { SectorTable } from '@zilo/pose3d-format/types/facet';

/** Drawn tiles in `table`; `drawnAzimuths` and `drawnScreenAngles` have this length. */
export function tileCountOf(table: SectorTable): number {
  return Math.max(-1, ...table.tile) + 1;
}
